angular.module('theme').directive('megaMenuToggle', function () {
	return {
		restrict: 'C',
		link: function ($scope, $element) {
			var open = false;
			var container = angular.element(document.querySelector('#mega-menu'));
			var menuClose = angular.element(container[0].querySelector('.close-menu'));
			var menuItem = angular.element($element[0]);
			var menuToggle = angular.element($element[0].querySelector('a'));
			var menuOverlay = angular.element(document.querySelector('#mega-menu-overlay'));

			menuToggle.bind('click', function (event) {
				event.preventDefault();
				menuEvent();
			});

			menuClose.bind('click', function (event) {
				event.preventDefault();
				menuEvent();
			});

			menuOverlay.bind('click', function() {
				menuEvent();
			});

			var menuEvent = function() {
				if(open) {
					menuItem.removeClass('open');
					container.removeClass('open');
					menuOverlay.removeClass('d-block');
				} else {
					menuItem.addClass('open');
					container.addClass('open');
					menuOverlay.show('d-block');
				}
				open = !open;
			};
		}
	};
});
